import { For, type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import type { CoreModel } from '../lib/fleet-live-core';
import { count } from '../lib/time';

// The Core canvas's text alternative (#6779): visually hidden, read by assistive tech. Each
// shown squad and its agents by role ("agents not reported" when the read sent no bucket for
// it), then "<K> more agents in no squad shown" when `agents.total` exceeds the drawn sum.

export function FleetLiveCoreText(props: { readonly model: CoreModel }): JSX.Element {
  return (
    <div class="sr-only">
      <ul aria-label={t('fleet.live.squads_label')}>
        <For each={props.model.squads}>
          {(s) => (
            <li>
              {s.agents === null
                ? t('fleet.live.sr_core_squad_none', { name: s.name })
                : t('fleet.live.sr_core_squad', {
                    name: s.name,
                    writing: count(s.agents.writing),
                    reviewing: count(s.agents.reviewing),
                    fixing: count(s.agents.fixing),
                  })}
            </li>
          )}
        </For>
      </ul>
      <Show when={props.model.unshown > 0}>
        <p>
          {tPlural('fleet.live.sr_core_unshown', props.model.unshown, {
            count: count(props.model.unshown),
          })}
        </p>
      </Show>
    </div>
  );
}
